
import { useContext, useEffect, useState } from 'react'
import { DashboardContext } from '../../../contextApi/DashboardContext';
import FormInput from '../dashboardComponents/FormInput';
import FormTextarea from '../dashboardComponents/FormTextarea';
import FormDropdown from '../dashboardComponents/FormDropdown';
import FormAddImage from '../dashboardComponents/FormAddImage';
import { AppContext } from '../../../contextApi/ContextApi';

export default function AddProductForm({website}) {
    const { setToastMessage, messagesOptions } = useContext(AppContext);
    const {handleSetCategory, handleAddProduct, productName, setProductName, setProductCategoryName, productCategoryName, setProductCategoryID, productCategoryID, productCompanyName, setProductCompanyName, productDesc, setProductDesc, productPrice, setProductPrice, productHasAmount, setProductHasAmount, productAmount, setProductAmount } = useContext(DashboardContext);
    const [] = useState();
    // Initiate the selected category to the first category on array if user did not select any
    useEffect(()=>{
        setProductCategoryName(website?.settings?.categories[0].name);
        setProductCategoryID(website?.settings?.categories[0]._id);
        setProductHasAmount(false);
        setProductAmount(1);
    },[])
    // useEffect(()=>{
    //     handleSetCategory();
    // },[productCategoryID])
    const handleChangeHasAmount = (e)=>{
        if(e.target.value === "כן"){
            setProductHasAmount(true);
        }
        else{
            setProductHasAmount(false);
        }
    }
    
    return (
        <form dir='rtl' className='dashboardForm' onSubmit={()=>{handleAddProduct(website, null, setToastMessage, messagesOptions)}}>
            <h2>הוסף מוצר</h2>
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"שם המוצר:"} id={"addProduct_name"} type={"text"} _value={productName} placeholder={"אנא הכנס שם מוצר"} onChangeAction={(e) => setProductName(e.target.value)} required={true} resetValue={true}/>
            <FormTextarea _class={"dashboardForm_section"} label={"תיאור המוצר:"} id={"addProduct_description"} _value={productDesc} placeholder={"הוסף תיאור קצר על המוצר"} onChangeAction={(e)=>{setProductDesc(e.target.value)}} required={true} resetValue={true}/>
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"עלות המוצר:"} id={"addProduct_price"} type={"number"} _value={productPrice} placeholder={"אנא הכנס מחיר מוצר"} onChangeAction={(e) => setProductPrice(e.target.value)} required={true}/>
            
            <FormDropdown defOption={"בחר מהאפשרויות הבאות"} hasLabel={true} label={"האם יש מלאי למוצר:"} id={"addProduct_dropDown"} list={["לא","כן"]} onChangeAction={(e) => {handleChangeHasAmount(e)}}/>
            {productHasAmount && <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"כמות זמינה במלאי:"} id={"addProduct_amount"} type={"number"} _value={productAmount} placeholder={"אנא הזן כמות זמינה במלאי"} onChangeAction={(e) => setProductAmount(e.target.value)} required={false} resetValue={true}/>}
            
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"שם היצרן:"} id={"addProduct_company"} type={"text"} _value={productCompanyName} placeholder={"אנא הכנס שם יצרן במידה ויש"} onChangeAction={(e) => {setProductCompanyName(e.target.value)}} required={false} resetValue={true}/>
            <FormDropdown defOption={"אנא בחר קטגוריה..."} hasLabel={true} label={"בחר קטגוריה:"} id={"addProduct_dropDown"} list={website?.settings?.categories} onChangeAction={(e) => {handleSetCategory(e, website)}}/>
            <FormAddImage website={website} action={handleAddProduct} toUpdateDoc={false} directory={"products"} dynamicPath={"settings.categories"} isArray={true} label={"הוסף תמונה"} text={"שמור"} type={"button"} _required={false} _id={"product_image_uploader"}/>
        </form>
    )
}
